{
  "name": "@thednp/domparser",
  "version": "0.1.5",
  "description": "🍝 Super light HTML parser for isomorphic applications.",
  "keywords": [
    "domparser",
    "html",
    "dom",
    "parser"
  ],
  "license": "MIT",
  "author": "thednp",
  "type": "module",
  "browser": "./dist/index.js",
  "main": "./dist/index.cjs",
  "types": "./dist/index.d.cts",
  "module": "./dist/index.js",
  "commonjs": "./dist/index.cjs",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./dom": {
      "import": "./dist/dom.js",
      "require": "./dist/dom.cjs"
    },
    "./dom-parser": {
      "import": "./dist/dom-parser.js",
      "require": "./dist/dom-parser.cjs"
    },
    "./parser": {
      "import": "./dist/parser.js",
      "require": "./dist/parser.cjs"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "pre-test": "pnpm clean-coverage",
    "dev": "vite serve demo --port 3000",
    "test": "pnpm pre-test && vitest --config vitest.config.mts",
    "test-ui": "pnpm pre-test && vitest --config vitest.config.mts --ui",
    "clean-coverage": "rm -rf coverage .nyc_output .coverage",
    "badges": "npx -p dependency-version-badge update-badge typescript vitest vite",
    "format": "deno fmt src",
    "lint": "pnpm lint:ts && pnpm check:ts",
    "lint:ts": "deno lint src",
    "check:ts": "tsc --noEmit",
    "fix:ts": "deno lint src --fix",
    "build": "tsdown",
    "prepublishOnly": "pnpm up && pnpm format && pnpm lint && pnpm build && pnpm badges"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/thednp/domparser.git"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  },
  "bugs": {
    "url": "https://github.com/thednp/domparser/issues"
  },
  "devDependencies": {
    "@types/jsdom": "^21.1.7",
    "@types/node": "^22.15.33",
    "@vitest/coverage-istanbul": "^3.2.4",
    "@vitest/ui": "^3.2.4",
    "jsdom": "^26.1.0",
    "tsdown": "^0.12.9",
    "typescript": "^5.8.3",
    "vite": "^6.3.5",
    "vitest": "^3.2.4"
  },
  "packageManager": "pnpm@8.6.12"
}
